import React, { useSyncExternalStore } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { ConnectedRouter } from 'connected-react-router';
// import { history } from '@/core/store';
import { getRoutesVersion, routes, subscribeRoutes } from '@/core/routes';
import WrappedRoute from './WrappedRoute';
import Layout from '@/core/Layout';
import NotFound from '@/core/NotFound';



const Router = (props) => {
	// Re-render when an async-loaded plugin registers routes, so a hard
	// refresh on a plugin URL swaps NotFound for the real page once the
	// plugin arrives (see the note in core/routes.jsx).
	useSyncExternalStore(subscribeRoutes, getRoutesVersion);

	return (
	// <ConnectedRouter history={history}>
	<BrowserRouter basename={import.meta.env.VITE_BASE_URL}>
		<Route
			render={({ location }) => (
				<Layout>
					<Switch
						location={location}
						key={location.key}
					>
						{routes.map(config => {
							return <WrappedRoute
								{...config.route}
								extras={config.extras}
								render={config.render}
								key={config.route.path}
							/>;
						})}
						<Route component={NotFound} />
					</Switch>
				</Layout>
			)}
		/>
	</BrowserRouter>
	);
};




export default Router;
